<script>
  import { scale, fade } from "svelte/transition";
  export let showPrivacy = false;
</script>

<style>
  .backdrop {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 5;
  }
  .privacy {
    background: white;
    border: 2px solid rgb(20, 20, 20);
    position: fixed;
    left: 5%;
    top: 4%;
    width: 90%;
    height: 92%;
    margin: auto;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
    z-index: 10;
    font-size: 1.2rem;
    overflow-y: scroll; /* has to be scroll, not auto */
    -webkit-overflow-scrolling: touch;
  }
  p {
    font-size: 1rem;
  }
  button {
    padding: 10px 15px;
    background: #0070a1;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    font-size: 0.9rem;
    margin: 15px;
    float: right;
    margin-right: 45px;
    border: none;
  }
  button:hover {
    background: #004a69;
    cursor: pointer;
  }
  @media (min-width: 768px) {
    .privacy {
      left: 3%;
      top: 5%;
      width: 94%;
      height: 90%;
    }
  }
</style>

{#if showPrivacy}
  <div class="backdrop" transition:fade on:click />
  <div class="privacy" transition:scale>
    <h3>Política de Privacidad</h3>
    <p>
      La presente Política de Privacidad establece los términos en que CV
      (Columna Vitae) a través del sitio:
      <a href="https://www.columna-vitae.com">https://www.columna-vitae.com</a>
      usa y protege la información que es proporcionada por sus usuarios al
      momento de utilizar su sitio web.
      <br />
      <br />
      En CV (Columna Vitae) estamos comprometidos con la seguridad de los datos
      de nuestros usuarios. Cuando le pedimos llenar los campos de información
      personal con la cual usted pueda ser identificado, lo hacemos asegurando
      que sólo se emplearán de acuerdo con los términos de este documento. Sin
      embargo esta Política de Privacidad puede cambiar con el tiempo o ser
      actualizada por lo que le recomendamos y enfatizamos revisar continuamente
      esta página para asegurarse que está de acuerdo con dichos cambios.
    </p>
    <h4>Información que es recogida</h4>
    <p>
      Nuestro sitio web podrá recoger información personal por ejemplo: Nombre,
      información de contacto como su dirección de correo electrónico y teléfono
      e información demográfica. Así mismo cuando sea necesario podrá ser
      requerida información específica para procesar algún pedido o realizar una
      entrega o facturación.
    </p>
    <h4>Uso de la información recogida</h4>
    <p>
      Nuestro sitio web
      <a href="https://www.columna-vitae.com">https://www.columna-vitae.com</a>
      emplea la información con el fin de proporcionar el mejor servicio
      posible, particularmente para mantener un registro de usuarios, de pedidos
      en caso que aplique, y mejorar nuestros productos y servicios. Es posible
      que sean enviados correos electrónicos periódicamente a través de nuestro
      sitio con ofertas especiales y otra información publicitaria que
      consideremos relevante para usted o que pueda brindarle algún beneficio,
      estos correos electrónicos serán enviados a la dirección que usted
      proporcione y podrán ser cancelados en cualquier momento
      <em>
        -para ello simplemente envíenos un email desde su cuenta de correo
        electrónico solicitando la cancelación de la misma
      </em>
      .
      <br />
      <br />
      En CV (Columna Vitae) estamos altamente comprometidos para cumplir con el
      compromiso de mantener su información segura. Usamos los sistemas más
      avanzados y los actualizamos constantemente para asegurarnos que no exista
      ningún acceso no autorizado.
    </p>
    <h4>Cookies</h4>
    <p>
      Una cookie se refiere a un fichero que es enviado con la finalidad de
      solicitar permiso para almacenarse en su ordenador, al aceptar dicho
      fichero se crea y la 'cookie' sirve entonces para tener información
      respecto al tráfico web, y también facilita las futuras visitas a una web
      recurrente. Otra función que tienen las cookies es que con ellas las web
      pueden reconocerte individualmente y por tanto brindarte el mejor servicio
      personalizado de su web.
      <br />
      <br />
      Nuestro sitio web
      <a href="https://www.columna-vitae.com">https://www.columna-vitae.com</a>
      actualmente no emplea cookies para poder identificar las páginas que son
      visitadas ni su frecuencia (Esta información normalmente es empleada para
      realizar análisis estadísticos). Usted puede eliminar las cookies en
      cualquier momento desde su ordenador. Sin embargo las cookies ayudan a
      proporcionar un mejor servicio de algunos sitios web, estás no dan acceso
      a información de su ordenador ni de usted, a menos de que usted así lo
      quiera y la proporcione directamente. Usted puede aceptar o negar el uso
      de cookies, sin embargo la mayoría de navegadores aceptan cookies
      automáticamente pues sirve para tener un mejor servicio web. También usted
      puede cambiar la configuración de su ordenador para declinar las cookies.
      <!-- Si se declinan es posible que no pueda utilizar
      algunos de nuestros servicios. -->
    </p>
    <h4>Enlaces a Terceros</h4>
    <p>
      Este sitio web pudiera contener enlaces a otros sitios que pudieran ser de
      su interés. Una vez que usted haga un clic en estos enlaces y abandone
      nuestra página, ya no tenemos control sobre al sitio al que es redirigido
      y por lo tanto no somos responsables de los términos o privacidad ni de la
      protección de sus datos en esos otros sitios terceros. Dichos sitios están
      sujetos a sus propias políticas de privacidad por lo cual es recomendable
      que los consulte para confirmar que usted está de acuerdo con estas.
    </p>
    <h4>Control de su información personal</h4>
    <p>
      En cualquier momento usted puede restringir la recopilación o el uso de la
      información personal que es proporcionada a nuestro sitio web. Cada vez
      que se le solicite rellenar un formulario, como el de alta de usuario,
      puede marcar o desmarcar la opción de recibir información por correo
      electrónico. En caso de que haya marcado la opción de recibir nuestro
      boletín o publicidad usted puede cancelarla en cualquier momento.
      <br />
      <br />
      Esta compañía no venderá, cederá ni distribuirá la información personal
      que es recopilada sin su consentimiento, salvo que sea requerido por un
      juez a través de una orden judicial.
      <br />
      <br />
      <em>
        CV (Columna Vitae) se reserva el derecho de cambiar los términos de la
        presente Política de Privacidad en cualquier momento.
      </em>
    </p>
    <hr />
    <button on:click>Aceptar</button>
  </div>
{/if}
